import formset from './formset.js';
import descriptor from './forms/setup.js';
import { makeOptions } from './record.js';

const SELECT = /(<select[^>]*>)(.*?)(<\/select>)/ims;
const COLUMNS = /(<div\s+id="columns"[^>]*>)(.*?)(<\/div>)/ims;

const makeCheckboxes = function(array, value, label, cls)
{
	let checkboxes = array.map((entry, index) =>
		`<label>
			${index % 2 ? entry[label] : ''}
			<input type="checkbox" class="${cls}" value="${entry[value]}" checked>
			${index % 2 ? '' : entry[label]}
		</label>`
	).join('\n');
	return checkboxes;
};

const setup = {

	init(columns)		// [{ index: 0, label: '' }, ...]
	{
		const sortable = (columns || []).filter((c) => !c.computed);
		let options = makeOptions(sortable.length ? sortable : columns, 'index', ['label']);
		let checkboxes = makeCheckboxes(columns, 'index', 'label', 'columns');
		descriptor.html = descriptor.html.replace(SELECT, '$1' + options + '$3');
		descriptor.html = descriptor.html.replace(COLUMNS, '$1' + checkboxes + '$3');
	},

	edit(callback, current_data)
	{
		let fs = formset.create(descriptor, (updated_data) =>
		{
			fs.destroy();
			callback?.(updated_data);
		});
		fs.init = (() =>
		{
			// keep_filter = "Preservar grade ao reabrir" (Configurar). 0 = desmarcado.
			const rawKeep = current_data?.keep_filter;
			const keepFilter = (rawKeep === 0 || rawKeep === '0' || rawKeep === false) ? 0 : 1;
			fs.form.setValues({
				'sort_column': current_data?.sort_column ?? 1,
				'sort_order': current_data?.sort_order ?? 1,
				'columns': current_data?.columns,
				'page_length': current_data?.page_length ?? 30,
				'keep_filter': keepFilter
			});
			Object.getPrototypeOf(fs).init.call(fs);
		})();
	},

};

export default setup;

